import React from "react";
import style from "./Menu.module.scss";
import List from "@material-ui/core/List";
import MenuItem from "./MenuItem";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setCurrentPage } from "../../../../actions";
import { Location } from "@reach/router";

function MenuIcon() {
	return (
		<span className="svg-md">
			<svg
				viewBox="0 0 24 24"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
			>
				<title>Stockholm-icons / Design / Layers</title>
				<desc>Created with Sketch.</desc>
				<defs></defs>
				<g>
					<title>ShMunIconColored</title>
					<path
						d="M5.5,10c-0.3-0.2-0.6-0.4-1-0.4s-0.7,0.1-1,0.4l-2.3,2.3l1.2,1.2C3.3,12.6,4,11.9,4,11.9c0.3-0.4,0.6-0.4,0.9,0L5.1,12
          l1.2-1.2C5.9,10.4,5.5,10,5.5,10"
					/>
					<path
						d="M7.2,14.1c0.1,0.1,0.2,0.3,0.2,0.5v3.2c0,0.3,0,0.4-0.1,0.5c-0.1,0.1-0.3,0.1-0.5,0.1H6.5v1.7h1.1c0.8,0,1.4-0.6,1.4-1.4
          v-4.4c0-0.4-0.2-0.9-0.5-1.2c0,0-0.2-0.2-0.5-0.5l-1.2,1.2"
					/>
					<path
						d="M9.9,19c-0.3,0.3-0.4,0.6-0.4,1c0,0.4,0.1,0.7,0.4,1l2.3,2.3l1.2-1.2c-0.9-0.9-1.7-1.7-1.7-1.7c-0.3-0.4-0.3-0.6,0-0.9
          l0.1-0.1l-1.2-1.2C10.3,18.6,9.9,19,9.9,19"
					/>
					<path
						d="M13.9,17.3c0.1-0.1,0.3-0.2,0.5-0.2h3.2c0.3,0,0.4,0,0.5,0.1c0.1,0.1,0.1,0.3,0.1,0.5V18H20v-1.1c0-0.8-0.6-1.4-1.4-1.4
          h-4.4c-0.4,0-0.9,0.2-1.2,0.5c0,0-0.2,0.2-0.5,0.5l1.2,1.2"
					/>
					<path
						d="M22,11.2c-0.9,0.9-1.7,1.7-1.7,1.7c-0.4,0.4-0.6,0.4-0.9,0l-0.1-0.1l-1.2,1.2c0.4,0.4,0.8,0.8,0.8,0.8
          c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l2.3-2.3L22,11.2z"
					/>
					<path
						d="M17.2,10.6C17,10.5,17,10.3,17,10.1V6.9c0-0.3,0-0.4,0.1-0.5c0.1-0.1,0.3-0.1,0.5-0.1h0.2V4.6l-1.1,0
          c-0.8,0-1.4,0.6-1.4,1.4v4.4c0,0.4,0.2,0.9,0.5,1.2c0,0,0.2,0.2,0.5,0.5l1.2-1.2"
					/>
					<path
						class="st0"
						d="M9.1,6c0-0.4-0.2-0.7-0.4-1C8.4,4.7,8,4.6,7.7,4.6l-3.3,0l0,1.7h2.4c0.5,0,0.7,0.2,0.7,0.7v0.2h1.7"
					/>
					<path
						class="st0"
						d="M7.4,10.1c0,0.2-0.1,0.4-0.2,0.5L5,12.8c-0.2,0.2-0.3,0.3-0.5,0.3S4.2,13,4,12.8l-0.1-0.1l-1.2,1.2l0.8,0.8
          c0.5,0.5,1.4,0.5,2,0l3.1-3.1c0.3-0.3,0.5-0.7,0.5-1.2c0,0,0-0.3,0-0.7H7.4"
					/>
					<path
						class="st0"
						d="M5.8,15.4c-0.4,0-0.7,0.2-1,0.4c-0.3,0.3-0.4,0.6-0.4,1l0,3.3h1.7c0-1.3,0-2.4,0-2.4c0-0.5,0.2-0.7,0.7-0.7H7
          v-1.7"
					/>
					<path
						class="st0"
						d="M15.3,18.7c0,0.4,0.2,0.7,0.4,1c0.3,0.3,0.6,0.4,1,0.4l3.3,0v-1.7c-1.3,0-2.4,0-2.4,0c-0.5,0-0.7-0.2-0.7-0.7
          v-0.2h-1.7C15.3,18.1,15.3,18.7,15.3,18.7"
					/>
					<path
						class="st0"
						d="M9.9,17.1c0.2,0,0.4,0.1,0.5,0.2l2.3,2.3c0.2,0.2,0.3,0.3,0.3,0.5c0,0.1-0.1,0.3-0.3,0.5l-0.1,0.1l1.2,1.2
          l0.8-0.8c0.5-0.5,0.5-1.4,0-2l-3.1-3.1c-0.3-0.3-0.7-0.5-1.2-0.5H9.5v1.7"
					/>
					<path
						class="st0"
						d="M17,14.6c0-0.2,0.1-0.4,0.2-0.5l2.3-2.3c0.2-0.2,0.3-0.3,0.5-0.3c0.1,0,0.3,0.1,0.5,0.3l0.1,0.1l1.2-1.2
          L20.9,10c-0.5-0.5-1.4-0.5-2,0l-3.1,3.1c-0.3,0.3-0.5,0.7-0.5,1.2c0,0,0,0.3,0,0.7H17"
					/>
					<path
						class="st0"
						d="M18.6,9.2c0.4,0,0.7-0.2,1-0.4c0.3-0.3,0.4-0.6,0.4-1l0-3.3l-1.7,0c0,1.3,0,2.4,0,2.4c0,0.5-0.2,0.7-0.7,0.7
          h-0.2v1.7"
					/>
					<path
						class="st0"
						d="M14.5,7.6c-0.2,0-0.4-0.1-0.5-0.2l-2.3-2.3c-0.2-0.2-0.3-0.3-0.3-0.5c0-0.1,0.1-0.3,0.3-0.5L11.8,4l-1.2-1.2
          L9.9,3.6c-0.5,0.5-0.5,1.4,0,2L13,8.7c0.3,0.3,0.7,0.5,1.2,0.5h0.7V7.6"
					/>
					<path
						d="M14.5,5.6c0.3-0.2,0.4-0.6,0.4-1s-0.1-0.7-0.4-1l-2.3-2.3L11,2.5c0.9,0.9,1.7,1.7,1.7,1.7c0.4,0.3,0.4,0.6,0,0.9l-0.1,0.1
          l1.2,1.2C14.1,6,14.5,5.6,14.5,5.6"
					/>
					<path
						d="M10.4,7.4c-0.1,0.1-0.3,0.2-0.5,0.2H6.7c-0.3,0-0.4,0-0.5-0.1C6.1,7.3,6.1,7.2,6.1,6.9V6.7H4.4l0,1.1
          c0,0.8,0.6,1.4,1.4,1.4h4.4c0.4,0,0.9-0.2,1.2-0.5c0,0,0.2-0.2,0.5-0.5l-1.2-1.2"
					/>
				</g>
			</svg>
		</span>
	);
}

function ManageMunicipalities() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				s <title>Stockholm-icons / Home / Building</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Home-_x2F_-Building">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path
							id="Rectangle-2_3_"
							className="st2"
							d="M4,21h16c0.6,0,1,0.4,1,1v0.4c0,0.3-0.3,0.6-0.6,0.6H3.6C3.3,23,3,22.7,3,22.4V22
			        C3,21.4,3.4,21,4,21z"
						/>
					</g>
				</g>
				<path
					id="Combined-Shape"
					className="st2"
					d="M13.5,21v-3c0-0.6-0.4-1-1-1h-1c-0.6,0-1,0.4-1,1v3H5V4c0-1.1,0.9-2,2-2h10
	        c1.1,0,2,0.9,2,2v17H13.5z M9,4C8.4,4,8,4.4,8,5v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V5c0-0.6-0.4-1-1-1H9z M14,4c-0.6,0-1,0.4-1,1
	        v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V5c0-0.6-0.4-1-1-1H14z M9,8C8.4,8,8,8.4,8,9v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V9
	        c0-0.6-0.4-1-1-1H9z M9,12c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1v-1c0-0.6-0.4-1-1-1H9z M14,12c-0.6,0-1,0.4-1,1v1
	        c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1v-1c0-0.6-0.4-1-1-1H14z M14,8h1c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1V9
	        C13,8.4,13.4,8,14,8z"
				/>
				<path
					id="Rectangle-2_1_"
					d="M20,21.5c0.3,0,0.5,0.2,0.5,0.5v0.4c0,0.1,0,0.1-0.1,0.1H3.6c-0.1,0-0.1,0-0.1-0.1V22
	        c0-0.3,0.2-0.5,0.5-0.5H20 M20,21H4c-0.6,0-1,0.4-1,1v0.4C3,22.7,3.3,23,3.6,23h16.8c0.3,0,0.6-0.3,0.6-0.6V22
	        C21,21.4,20.6,21,20,21L20,21z"
				/>
			</svg>
		</span>
	);
}

function MunicipalitiesSections() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{enable-background:new    ;}\n",
					}}
				/>
				<title>Stockholm-icons / Home / Building</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Home-_x2F_-Building">
					<rect id="bound" className="st0" width={24} height={24} />
				</g>
				<g className="st1">
					<path
						id="Combined-Shape_3_"
						className="st2"
						d="M13.5,21v-3c0-0.6-0.4-1-1-1h-1c-0.6,0-1,0.4-1,1v3H5V4c0-1.1,0.9-2,2-2h10
		        c1.1,0,2,0.9,2,2v17H13.5z M9,4C8.4,4,8,4.4,8,5v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V5c0-0.6-0.4-1-1-1H9z M14,4c-0.6,0-1,0.4-1,1
		        v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V5c0-0.6-0.4-1-1-1H14z M9,8C8.4,8,8,8.4,8,9v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1V9
		        c0-0.6-0.4-1-1-1H9z M9,12c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1v-1c0-0.6-0.4-1-1-1H9z M14,12c-0.6,0-1,0.4-1,1v1
		        c0,0.6,0.4,1,1,1h1c0.6,0,1-0.4,1-1v-1c0-0.6-0.4-1-1-1H14z M14,8h1c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1V9
		        C13,8.4,13.4,8,14,8z"
					/>
				</g>
				<path
					id="Combined-Shape_1_"
					d="M17,2.5c0.8,0,1.5,0.7,1.5,1.5v16.5H14V18c0-0.8-0.7-1.5-1.5-1.5h-1c-0.8,0-1.5,0.7-1.5,1.5v2.5H5.5
	        V4c0-0.8,0.7-1.5,1.5-1.5H17 M17,2H7C5.9,2,5,2.9,5,4v17h5.5v-3c0-0.6,0.4-1,1-1h1c0.6,0,1,0.4,1,1v3H19V4C19,2.9,18.1,2,17,2L17,2z
	        "
				/>
				<path
					id="Rectangle-Copy-2_2_"
					className="st2"
					d="M14,8h1c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-1c-0.6,0-1-0.4-1-1V9C13,8.4,13.4,8,14,8
	        z"
				/>
				<g className="st3">
					<path
						id="Rectangle-2_3_"
						className="st2"
						d="M4,21h16c0.6,0,1,0.4,1,1v0.4c0,0.3-0.3,0.6-0.6,0.6H3.6C3.3,23,3,22.7,3,22.4V22
		        C3,21.4,3.4,21,4,21z"
					/>
				</g>
			</svg>
		</span>
	);
}

function MunicipalitiesJobs() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				<title>Stockholm-icons / Clothes / Shirt</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Clothes-_x2F_-Shirt">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path
							id="Combined-Shape_4_"
							className="st2"
							d="M6.2,4.1C6.7,3.4,7.6,3,8.5,3h7c0.9,0,1.8,0.4,2.3,1.1c0,0,0,0,0.1,0l4.7,2.7
			        c0.5,0.3,0.6,0.9,0.4,1.4l-1.7,2.9c-0.3,0.5-0.9,0.6-1.4,0.4l-1.4-0.8V19c0,0.6-0.4,1-1,1h-11c-0.6,0-1-0.4-1-1v-8.4l-1.4,0.8
			        c-0.5,0.3-1.1,0.1-1.4-0.4L1,8.2C0.8,7.7,0.9,7.1,1.4,6.8L6.2,4.1C6.1,4.1,6.2,4.1,6.2,4.1z"
						/>
					</g>
					<g>
						<path
							d="M10.7,8.3l-1.3,6.9c0,0.2,0,0.5,0.2,0.7l1.9,2c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l1.9-2c0.2-0.2,0.2-0.4,0.2-0.7l-1.3-6.9
			        H10.7z"
						/>
						<path
							d="M22.6,6.8l-4.7-2.7c0,0,0,0-0.1,0C17.3,3.4,16.4,3,15.5,3h-0.8H9.3H8.5C7.6,3,6.7,3.4,6.2,4.1c0,0,0,0-0.1,0L1.4,6.8
			        C0.9,7.1,0.8,7.7,1,8.2l1.7,2.9c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1l1.4-0.8V19c0,0.6,0.4,1,1,1h11c0.6,0,1-0.4,1-1v-8.4
			        l1.4,0.8c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.7-0.2,0.9-0.5L23,8.2C23.2,7.7,23.1,7.1,22.6,6.8z M22.5,8l-1.7,2.9
			        c-0.1,0.2-0.3,0.3-0.4,0.3c-0.1,0-0.2,0-0.2-0.1l-1.4-0.8L18,9.8v0.9V19c0,0.3-0.2,0.5-0.5,0.5h-11C6.2,19.5,6,19.3,6,19v-8.4V9.8
			        l-0.8,0.4L3.8,11c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0-0.3-0.1-0.4-0.3L1.5,8C1.3,7.7,1.4,7.4,1.7,7.3l4.7-2.7l0.1,0l0.1-0.1
			        C7,3.8,7.7,3.5,8.5,3.5h0.3L8.4,3.9c-0.3,0.3-0.3,0.8,0,1.1l1.9,1.9c0,0,0.1,0,0.1,0h3c0,0,0.1,0,0.1,0l1.9-1.9
			        c0.3-0.3,0.3-0.8,0-1.1l-0.4-0.4h0.3c0.7,0,1.5,0.3,1.9,0.9l0.1,0.1l0.1,0l4.7,2.7C22.6,7.4,22.7,7.7,22.5,8z"
						/>
					</g>
				</g>
			</svg>
		</span>
	);
}

function ManageServices() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				<title>Stockholm-icons / Files / File</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Files-_x2F_-File">
					<polygon
						id="Shape"
						className="st0"
						points="0,0 24,0 24.4,24 0.4,24 	"
					/>
					<g className="st1">
						<path
							id="Combined-Shape_4_"
							d="M6.3,2.2h7c0.4,0,0.7,0.1,1,0.4l4.8,4c0.3,0.3,0.5,0.7,0.5,1.1v10.6c0,1.8,0,1.9-1.9,1.9H6.3
			        c-1.8,0-1.9-0.1-1.9-1.9V4.1C4.4,2.3,4.4,2.2,6.3,2.2z"
						/>
					</g>
					<path
						id="Rectangle"
						className="st2"
						d="M7.5,7.2h7c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-7c-0.6,0-1-0.4-1-1l0,0
		        C6.5,7.6,7,7.2,7.5,7.2z"
					/>
					<path
						id="Rectangle-Copy"
						className="st2"
						d="M7.5,11.2h3c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1h-3c-0.6,0-1-0.4-1-1l0,0
		        C6.5,11.6,7,11.2,7.5,11.2z"
					/>
					<path
						id="Combined-Shape_1_"
						className="st2"
						d="M14.6,16.6v-1.7h1.7l1.3-1.3l1.3,1.3h2.1V17l1.2,1.2l-1.2,1.2v2.1H19l-1.3,1.3
		        l-1.3-1.3h-1.7v-1.7L13,18.1L14.6,16.6z M17.8,19.5c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4S17.1,19.5,17.8,19.5z
		        "
					/>
					<path
						id="Combined-Shape_2_"
						d="M13.3,2.2c0.4,0,0.7,0.1,1,0.4l4.8,4c0.3,0.3,0.5,0.7,0.5,1.1v10.6c0,1.8,0,1.9-1.9,1.9H6.3
		        c-1.8,0-1.9-0.1-1.9-1.9V4.1c0-1.8,0-1.9,1.9-1.9H13.3 M13.3,1.7h-7c-2.2,0-2.4,0.4-2.4,2.4v14.2c0,2,0.2,2.4,2.4,2.4h11.4
		        c2.2,0,2.4-0.4,2.4-2.4V7.7c0-0.6-0.3-1.1-0.7-1.5l-4.8-4C14.2,1.9,13.8,1.7,13.3,1.7L13.3,1.7z"
					/>
				</g>
			</svg>
		</span>
	);
}

function ServiceCategories() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n",
					}}
				/>
				<title>Stockholm-icons / Layout / Layout-4-blocks</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Layout-_x2F_-Layout-4-blocks">
					<rect id="bound" className="st0" width={24} height={24} />
					<g>
						<g>
							<g className="st1">
								<path
									id="Combined-Shape_7_"
									d="M14,2h3.4c0.2,0,0.3,0.1,0.4,0.2L19.9,4c0.1,0.1,0.2,0.3,0.2,0.5v5.6c0,0.8,0,0.9-0.8,0.9H14
					        c-0.8,0-0.8-0.1-0.8-0.9V2.9C13.2,2.1,13.2,2,14,2z"
								/>
							</g>
						</g>
						<g>
							<g className="st1">
								<path
									id="Combined-Shape_6_"
									d="M14,13h3.4c0.2,0,0.3,0.1,0.4,0.2l2.1,1.8c0.1,0.1,0.2,0.3,0.2,0.5v5.6c0,0.8,0,0.9-0.8,0.9H14
					        c-0.8,0-0.8-0.1-0.8-0.9v-7.3C13.2,13.1,13.2,13,14,13z"
								/>
							</g>
						</g>
						<g>
							<g className="st1">
								<path
									id="Combined-Shape_9_"
									d="M4.8,13h3.4c0.2,0,0.3,0.1,0.4,0.2l2.1,1.8c0.1,0.1,0.2,0.3,0.2,0.5v5.6c0,0.8,0,0.9-0.8,0.9
					        H4.8C4,22,4,21.9,4,21.1v-7.3C4,13.1,4,13,4.8,13z"
								/>
							</g>
							<g>
								<path d="M6.2,18.5c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h2.6c0.2,0,0.4-0.2,0.4-0.4S9,18.5,8.8,18.5H6.2z" />
								<path d="M8.8,18.5H6.2c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h2.6c0.2,0,0.4-0.2,0.4-0.4S9,18.5,8.8,18.5L8.8,18.5z" />
							</g>
							<g>
								<path d="M15.4,18.5c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4H18c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H15.4z" />
								<path d="M18,18.5h-2.6c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4H18c0.2,0,0.4-0.2,0.4-0.4S18.2,18.5,18,18.5L18,18.5z" />
							</g>
						</g>
						<path
							id="Combined-Shape_5_"
							d="M4.8,2h3.4c0.2,0,0.3,0.1,0.4,0.2L10.8,4C10.9,4.1,11,4.3,11,4.5v5.6c0,0.8,0,0.9-0.8,0.9H4.8
			        C4,11,4,10.9,4,10.1V2.9C4,2.1,4,2,4.8,2z M6.2,6.7C6,6.7,5.8,6.9,5.8,7.1c0,0.2,0.2,0.4,0.4,0.4h2.6c0.2,0,0.4-0.2,0.4-0.4
			        c0-0.2-0.2-0.4-0.4-0.4H6.2z"
						/>
					</g>
				</g>
				<path d="M15.4,7.3c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4H18c0.2,0,0.4-0.2,0.4-0.4S18.2,7.3,18,7.3H15.4z" />
				<path
					id="Combined-Shape_4_"
					d="M17.4,13.5C17.5,13.5,17.5,13.5,17.4,13.5l2.2,1.8c0,0,0.1,0.1,0.1,0.1v5.6c0,0.1,0,0.3,0,0.4
	        c-0.1,0-0.2,0-0.3,0H14c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0-0.4v-7.3c0-0.1,0-0.3,0-0.4c0.1,0,0.2,0,0.3,0H17.4 M17.4,13H14
	        c-0.8,0-0.8,0.1-0.8,0.9v7.3c0,0.8,0,0.9,0.8,0.9h5.4c0.8,0,0.8-0.1,0.8-0.9v-5.6c0-0.2-0.1-0.4-0.2-0.5l-2.1-1.8
	        C17.7,13.1,17.6,13,17.4,13L17.4,13z"
				/>
				<path
					id="Combined-Shape_1_"
					d="M8.3,13.5C8.3,13.5,8.3,13.5,8.3,13.5l2.2,1.8c0,0,0.1,0.1,0.1,0.1v5.6c0,0.1,0,0.3,0,0.4
	        c-0.1,0-0.2,0-0.3,0H4.8c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0-0.4v-7.3c0-0.1,0-0.3,0-0.4c0.1,0,0.2,0,0.3,0H8.3 M8.3,13H4.8
	        C4,13,4,13.1,4,13.9v7.3C4,21.9,4,22,4.8,22h5.4c0.8,0,0.8-0.1,0.8-0.9v-5.6c0-0.2-0.1-0.4-0.2-0.5l-2.1-1.8C8.6,13.1,8.4,13,8.3,13
	        L8.3,13z"
				/>
				<path
					id="Combined-Shape_2_"
					d="M17.4,2.5C17.5,2.5,17.5,2.5,17.4,2.5l2.2,1.8c0,0,0.1,0.1,0.1,0.1v5.6c0,0.1,0,0.3,0,0.4
	        c-0.1,0-0.2,0-0.3,0H14c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0-0.4V2.9c0-0.1,0-0.3,0-0.4c0.1,0,0.2,0,0.3,0H17.4 M17.4,2H14
	        c-0.8,0-0.8,0.1-0.8,0.9v7.3c0,0.8,0,0.9,0.8,0.9h5.4c0.8,0,0.8-0.1,0.8-0.9V4.5c0-0.2-0.1-0.4-0.2-0.5l-2.1-1.8
	        C17.7,2.1,17.6,2,17.4,2L17.4,2z"
				/>
			</svg>
		</span>
	);
}

function ServiceDropDown() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				<title>Stockholm-icons / Text / Menu</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Text-_x2F_-Menu">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path d="M17.1,20.6H6.8c-0.9,0-1.6-0.7-1.6-1.6V6.5h13.5V19C18.7,19.8,18,20.6,17.1,20.6z" />
					</g>
				</g>
				<path
					d="M18.2,7v12c0,0.6-0.5,1.1-1.1,1.1H6.8c-0.6,0-1.1-0.5-1.1-1.1V7H18.2 M18.7,6.5H5.2V19c0,0.9,0.7,1.6,1.6,1.6h10.3
	        c0.9,0,1.6-0.7,1.6-1.6V6.5L18.7,6.5z"
				/>
				<path d="M8.5,10.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h7c0.6,0,1-0.4,1-1s-0.4-1-1-1H8.5z" />
				<path d="M8.5,14.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h3c0.6,0,1-0.4,1-1s-0.4-1-1-1H8.5z" />
				<path
					className="st2"
					d="M5.5,3.5h13C19.3,3.5,20,4.2,20,5l0,0c0,0.8-0.7,1.5-1.5,1.5h-13C4.7,6.5,4,5.8,4,5l0,0C4,4.2,4.7,3.5,5.5,3.5z
	         M13.2,4c0.1-0.1,0.2,0.1,0.4,0.2c0.1,0.1,0.1,0.2,0,0.3l-1.4,1.3C12,6,11.9,6,11.8,5.9l-1.4-1.2c-0.1-0.1-0.1-0.2,0-0.3
	        c0.1-0.1,0.2-0.3,0.4-0.2l1.2,1L13.2,4z"
				/>
			</svg>
		</span>
	);
}

function ManageSlider() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{opacity:0.3;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill:none;}\n",
					}}
				/>
				<title>Stockholm-icons / Design / Image</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Design-_x2F_-Image">
					<g className="st0">
						<path
							id="Rectangle-25_4_"
							className="st1"
							d="M6.7,5.6h10.6c1.5,0,2.7,1.2,2.7,2.7v10c0,1.5-1.2,2.7-2.7,2.7H6.7
			        c-1.5,0-2.7-1.2-2.7-2.7v-10C4,6.8,5.2,5.6,6.7,5.6z"
						/>
					</g>
					<polygon
						id="Shape"
						className="st2"
						points="0,0 24,0 24,24 0,24 	"
					/>
				</g>
				<path
					d="M18,3.5H6c-1.7,0-3,1.3-3,3v9c0,0.9,0.4,1.7,1,2.2v0.5c0,1.5,1.2,2.7,2.7,2.7h10.6c1.5,0,2.7-1.2,2.7-2.7v-0.5
	        c0.6-0.5,1-1.3,1-2.2v-9C21,4.8,19.7,3.5,18,3.5z M9.5,9.5l4.5,6H5L9.5,9.5z M13,9.5c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3
	        S13,11.2,13,9.5z M19.5,18.2c0,1.2-1,2.2-2.2,2.2H6.7c-1.2,0-2.2-1-2.2-2.2v-0.1C5,18.3,5.5,18.5,6,18.5h12c0.5,0,1-0.2,1.5-0.4
	        V18.2z"
				/>
			</svg>
		</span>
	);
}

function SuggestionComplaints() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				<g id="Stockholm-icons-_x2F_-Communication-_x2F_-Mail">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path
							id="Combined-Shape_4_"
							className="st2"
							d="M5.9,10.9h12.2c1,0,1.7,0.6,1.7,1.4v6.4c0,0.8-0.8,1.4-1.7,1.4H5.9
			        c-1,0-1.7-0.6-1.7-1.4v-6.4C4.2,11.5,4.9,10.9,5.9,10.9z"
						/>
					</g>
					<title>Stockholm-icons / Communication / Mail</title>
					<desc>Created with Sketch.</desc>
					<path
						className="st2"
						d="M19,3H5C3.9,3,3,3.9,3,5v9c0,0.8,0.5,1.5,1.2,1.8v2.8C4.2,19.4,5,20,5.9,20h12.2c1,0,1.7-0.6,1.7-1.4v-2.8
		        c0.7-0.3,1.2-1,1.2-1.8V5C21,3.9,20.1,3,19,3z M4.8,5.2c0.2-0.4,0.7-0.5,1-0.3L12,8.2l6.1-3.3c0.4-0.2,0.8-0.1,1,0.3s0.1,0.8-0.3,1
		        l-6.5,3.5c-0.2,0.1-0.5,0.1-0.7,0L5.1,6.2C4.8,6,4.6,5.5,4.8,5.2z M19.3,18.7c0,0.5-0.6,0.9-1.2,0.9H5.9c-0.7,0-1.2-0.4-1.2-0.9V16
		        c0.1,0,0.2,0,0.3,0h14c0.1,0,0.2,0,0.3,0V18.7z"
					/>
				</g>
			</svg>
		</span>
	);
}

function UserManagement() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n",
					}}
				/>
				<title>Stockholm-icons / General / User</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-General-_x2F_-User">
					<polygon
						id="Shape"
						className="st0"
						points="0,0 24,0 24,24 0,24 	"
					/>
					<g className="st1">
						<path
							id="Mask_1_"
							d="M11.4,10.1c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S13.6,10.1,11.4,10.1z"
						/>
					</g>
					<g>
						<path
							d="M12.4,17.2l1.6-1.5V14h1.7l0.8-0.8c-1.5-0.8-3.2-1.1-5.2-1.1c-4.7,0-8.6,2.4-9,7.2c0,0.3,0.5,0.8,0.7,0.8
			        c4.3,0,8,0,11.1,0v-1.2L12.4,17.2z"
						/>
						<g className="st1">
							<path
								d="M20.4,16.1V14h-2.1L17,12.7l-0.5,0.5L15.7,14H14v1.7l-1.6,1.5l1.7,1.7v1.2v0.5h1.7l1.3,1.3l1.3-1.3h2v-2.1l1.2-1.2
				        L20.4,16.1z M17.2,15.8c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c-0.7,0-1.4-0.6-1.4-1.4C15.8,16.4,16.4,15.8,17.2,15.8z"
							/>
						</g>
					</g>
					<path
						d="M11.4,10.4c-2.3,0-4.3-1.9-4.3-4.3S9,1.9,11.4,1.9c2.3,0,4.3,1.9,4.3,4.3S13.7,10.4,11.4,10.4z M11.4,2.4
		        C9.3,2.4,7.6,4,7.6,6.1s1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8S13.4,2.4,11.4,2.4z"
					/>
					<path
						d="M17.1,22.3l-1.4-1.4h-1.8V19l-1.8-1.8l1.7-1.6v-1.8h1.8l1.4-1.4l1.4,1.4h2.2V16l1.3,1.3l-1.3,1.3v2.2h-2.1L17.1,22.3z
		         M14.4,20.3H16l1.2,1.2l1.2-1.2h1.9v-2l1.1-1.1l-1.1-1.1v-2h-2L17,13.1l-1.2,1.2h-1.6v1.6l-1.5,1.4l1.6,1.6V20.3z M17.2,18.8
		        c-0.8,0-1.6-0.7-1.6-1.7c0-0.9,0.7-1.7,1.6-1.7s1.7,0.7,1.7,1.7S18.2,18.8,17.2,18.8z M17.2,16c-0.7,0-1.1,0.5-1.1,1.2
		        c0,0.7,0.6,1.2,1.1,1.2c0.7,0,1.2-0.5,1.2-1.2S17.9,16,17.2,16z"
					/>
				</g>
			</svg>
		</span>
	);
}

function UsersGroups() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;enable-background:new    ;}\n",
					}}
				/>
				<title>Stockholm-icons / Files / User-folder</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Files-_x2F_-User-folder">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path
							id="Combined-Shape_1_"
							className="st2"
							d="M3.5,21h17c0.8,0,1.5-0.7,1.5-1.5v-11C22,7.7,21.3,7,20.5,7H10L7.4,4.4
			        C7.2,4.2,6.8,4,6.4,4H3.5C2.7,4,2,4.7,2,5.5v14C2,20.3,2.7,21,3.5,21z"
						/>
					</g>
					<path
						d="M20.5,21.3h-17c-1,0-1.8-0.8-1.8-1.8v-14c0-1,0.8-1.8,1.8-1.8h2.9c0.5,0,0.9,0.2,1.2,0.5l2.5,2.5h10.4c1,0,1.8,0.8,1.8,1.8
		        v11C22.3,20.5,21.5,21.3,20.5,21.3z M3.5,4.3c-0.7,0-1.3,0.6-1.3,1.3v14c0,0.7,0.6,1.3,1.3,1.3h17c0.7,0,1.3-0.6,1.3-1.3v-11
		        c0-0.7-0.6-1.3-1.3-1.3H9.9L7.3,4.6C7,4.4,6.7,4.3,6.4,4.3H3.5z"
					/>
				</g>
				<path
					id="Mask"
					className="st3"
					d="M12,13c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,13,12,13z"
				/>
				<path
					id="Mask-Copy"
					className="st3"
					d="M7,18.5c0.2-3,2.4-4.5,5-4.5c2.7,0,4.8,1.4,5,4.5c0,0.1,0,0.5-0.4,0.5c-2.1,0-5.1,0-9.2,0
	        C7.3,19,7,18.7,7,18.5z"
				/>
			</svg>
		</span>
	);
}

function MunicipalitiesCenters() {
	return (
		<span className="svg-md">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 24 24"
				style={{ enableBackground: "new 0 0 24 24" }}
				xmlSpace="preserve"
			>
				<style
					type="text/css"
					dangerouslySetInnerHTML={{
						__html: "\n\t.st0{fill:none;}\n\t.st1{opacity:0.3;enable-background:new    ;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n",
					}}
				/>
				<title>Stockholm-icons / Home / Building</title>
				<desc>Created with Sketch.</desc>
				<g id="Stockholm-icons-_x2F_-Home-_x2F_-Building">
					<rect id="bound" className="st0" width={24} height={24} />
					<g className="st1">
						<path
							id="Combined-Shape_2_"
							className="st2"
							d="M14,20.4H11H5.7V3.8c0-1.1,0.9-2,2-2h9.8c1.1,0,2,0.9,2,2v16.6H14z M9.6,3.8
			        c-0.5,0-1,0.4-1,1v1c0,0.5,0.4,1,1,1h1c0.5,0,1-0.4,1-1v-1c0-0.5-0.4-1-1-1H9.6z M14.5,3.8c-0.5,0-1,0.4-1,1v1c0,0.5,0.4,1,1,1h1
			        c0.5,0,1-0.4,1-1v-1c0-0.5-0.4-1-1-1H14.5z M9.6,7.7c-0.5,0-1,0.4-1,1v1c0,0.5,0.4,1,1,1h1c0.5,0,1-0.4,1-1v-1c0-0.5-0.4-1-1-1
			        H9.6z M14.5,11.6c-0.5,0-1,0.4-1,1v1c0,0.5,0.4,1,1,1h1c0.5,0,1-0.4,1-1v-1c0-0.5-0.4-1-1-1H14.5z M14.5,7.7h1c0.5,0,1,0.4,1,1v1
			        c0,0.5-0.4,1-1,1h-1c-0.5,0-1-0.4-1-1v-1C13.5,8.2,13.9,7.7,14.5,7.7z"
						/>
					</g>
				</g>
				<path
					id="Combined-Shape"
					className="st2"
					d="M9,20.6v-1.5c0-0.3-0.2-0.5-0.6-0.5H7.8c-0.3,0-0.6,0.2-0.6,0.5v1.5h-3v-8.3
	        c0-0.5,0.5-1,1.1-1h5.5c0.6,0,1.1,0.4,1.1,1v8.3H9z M6.7,12.4c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
	        c0.3,0,0.5-0.2,0.5-0.5v-0.5c0-0.3-0.2-0.5-0.5-0.5H6.7z M9.1,12.4c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
	        c0.3,0,0.5-0.2,0.5-0.5v-0.5c0-0.3-0.2-0.5-0.5-0.5H9.1z M6.7,14.3c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
	        c0.3,0,0.5-0.2,0.5-0.5v-0.5c0-0.3-0.2-0.5-0.5-0.5H6.7z M6.7,16.3c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
	        c0.3,0,0.5-0.2,0.5-0.5v-0.5c0-0.3-0.2-0.5-0.5-0.5H6.7z M9.1,16.3c-0.3,0-0.5,0.2-0.5,0.5v0.5c0,0.3,0.2,0.5,0.5,0.5h0.5
	        c0.3,0,0.5-0.2,0.5-0.5v-0.5c0-0.3-0.2-0.5-0.5-0.5H9.1z M9.1,14.3h0.5c0.3,0,0.5,0.2,0.5,0.5v0.5c0,0.3-0.2,0.5-0.5,0.5H9.1
	        c-0.3,0-0.5-0.2-0.5-0.5v-0.5C8.6,14.6,8.8,14.3,9.1,14.3z"
				/>
				<path
					className="st2"
					d="M20,20.4h-0.4V3.8c0-1.2-1-2.2-2.2-2.2H7.6c-1.2,0-2.2,1-2.2,2.2v16.6H4c-0.6,0-1,0.4-1,1v0.4
	        c0,0.3,0.3,0.6,0.6,0.6h16.8c0.3,0,0.6-0.3,0.6-0.6v-0.4C21,20.9,20.6,20.4,20,20.4z M5.9,3.8c0-0.9,0.8-1.7,1.7-1.7h9.8
	        c0.9,0,1.7,0.8,1.7,1.7v16.3h-4.8h-3.5H5.9V3.8z"
				/>
			</svg>
		</span>
	);
}

function UsersDashboardMenu() {
	return (
		<span className="svg-md">
			<svg
				fill="#000000"
				height="200px"
				width="200px"
				version="1.1"
				id="Layer_1"
				viewBox="0 0 512 512"
			>
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g id="SVGRepo_iconCarrier">
					{" "}
					<g transform="translate(1 1)">
						{" "}
						<g>
							{" "}
							<g>
								{" "}
								<path d="M244.76,343.747c3.413,0.853,6.827,0.853,10.24,0.853c16.213,0,30.72-9.387,38.4-23.893 c1.707-4.267,4.267-9.387,6.827-14.507c7.68-14.507,14.507-29.867,23.04-44.373l24.747-40.96 c1.707-3.413,0.853-6.827-1.707-10.24c-2.56-3.413-6.827-3.413-10.24-1.707l-40.96,24.747 c-14.507,8.533-29.867,16.213-44.373,23.04c-4.267,1.707-9.387,4.267-14.507,6.827c-17.92,9.387-27.307,29.013-23.04,48.64 C216.6,327.533,229.4,340.333,244.76,343.747z M243.907,278.893c4.267-2.56,9.387-4.267,14.507-6.827 c15.36-7.68,31.573-15.36,46.08-23.893l11.093-6.827l-6.827,11.093c-9.387,15.36-17.067,30.72-23.893,46.08 c-1.707,5.12-4.267,9.387-6.827,14.507c-5.12,11.093-17.067,16.213-29.013,13.653c-9.387-1.707-17.067-9.387-18.773-18.773 C227.693,295.96,232.813,284.013,243.907,278.893z"></path>{" "}
								<path d="M492.719,207.208c-0.108-0.575-0.27-1.146-0.492-1.702c-0.223-0.558-0.507-1.069-0.837-1.537 c-12.787-30.616-31.365-58.265-54.348-81.565c-0.324-0.482-0.701-0.944-1.135-1.378s-0.896-0.811-1.378-1.135 C388.233,74.226,324.764,45.933,255,45.933c-33.418,0-65.389,6.5-94.725,18.281c-0.575,0.108-1.146,0.27-1.701,0.492 c-0.557,0.223-1.069,0.507-1.537,0.837c-30.616,12.787-58.265,31.365-81.565,54.348c-0.482,0.324-0.944,0.701-1.378,1.135 s-0.812,0.896-1.135,1.378C27.293,168.7-1,232.169-1,301.933c0,58.027,18.773,113.493,55.467,158.72 c1.707,2.56,4.267,3.413,6.827,3.413h387.413c2.56,0,5.12-0.853,6.827-3.413C492.227,415.427,511,359.96,511,301.933 C511,268.515,504.5,236.544,492.719,207.208z M445.293,447H65.56c-11.539-14.88-21.122-30.844-28.695-47.616l23.575-9.557 c4.267-1.707,5.973-6.827,4.267-11.093c-1.707-4.267-6.827-5.973-11.093-4.267l-23.11,9.369 c-8.574-23.342-13.394-48.021-14.278-73.369H75.8c5.12,0,8.533-3.413,8.533-8.533S80.92,293.4,75.8,293.4H16.237 c0.957-26.907,6.416-52.715,15.648-76.694L55.32,226.84c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-5.12 c1.707-4.267,0-9.387-4.267-11.093l-23.672-10.237c10.699-22.831,24.906-43.721,41.922-61.967l17.59,17.59 c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56c3.413-3.413,3.413-8.533,0-11.947l-17.59-17.59 c19.117-17.828,41.131-32.581,65.244-43.438l9.52,23.482c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707,0,3.413-0.853 c4.267-1.707,5.973-6.827,4.267-11.093l-9.329-23.012c23.021-8.463,47.679-13.452,73.329-14.364v59.563 c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533V63.17c26.907,0.957,52.715,6.416,76.694,15.648l-10.134,23.436 c-1.707,4.267,0,9.387,4.267,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,6.827-2.56,7.68-5.12l10.237-23.672 c22.831,10.699,43.721,24.906,61.967,41.922l-17.59,17.59c-3.413,3.413-3.413,8.533,0,11.947c1.707,1.707,3.413,2.56,5.973,2.56 c1.707,0,4.267-0.853,5.973-2.56l17.59-17.59c17.828,19.117,32.581,41.131,43.438,65.244l-23.482,9.52 c-4.267,1.707-5.973,6.827-4.267,11.093c0.853,3.413,4.267,5.12,7.68,5.12c0.853,0,1.707-0.853,3.413-0.853l23.013-9.329 c8.463,23.021,13.452,47.679,14.364,73.329H434.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h59.575 c-0.927,26.593-6.172,52.45-15.418,76.799l-23.677-10.239c-4.267-1.707-9.387,0-11.093,4.267c-1.707,4.267,0,9.387,4.267,11.093 l23.981,10.37C464.644,418.298,455.773,433.121,445.293,447z"></path>{" "}
								<path d="M246.467,353.133c-51.2,0-91.307,25.6-102.4,65.707c0,2.56,0,5.973,1.707,7.68c1.707,2.56,4.267,3.413,6.827,3.413 h187.733c2.56,0,5.12-0.853,6.827-3.413c1.707-2.56,2.56-5.12,1.707-7.68C336.92,378.733,297.667,353.133,246.467,353.133z M251.302,412.867l-14.222-21.333c-2.56-4.267-7.68-5.12-11.947-2.56c-4.267,2.56-5.12,7.68-2.56,11.947l7.964,11.947H165.4 c12.8-26.453,43.52-42.667,81.92-42.667c37.547,0,68.267,16.213,81.067,42.667H251.302z"></path>{" "}
							</g>{" "}
						</g>{" "}
					</g>{" "}
				</g>
			</svg>
		</span>
	);
}

const Menu = (props) => {
	const { t, i18n } = useTranslation("common");

	const allowedScreens = props.currentUser.Data.User_Permissions.map(
		(item) => item.User_Screen_Code
	);

	let allowedPagesMain = allowedScreens.map((item) => {
		if (item === "departments") {
			return {
				name: `${t("departments")} `,
				link: `/departments`,
				active: props.currentPage === "/departments" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "municipality-management") {
			return {
				name: `${t("municipalAdministrations")} `,
				link: `/municipality-management`,
				active:
					props.currentPage === "/municipality-management"
						? true
						: false,
				Icon: <MunicipalitiesSections />,
			};
		}
		if (item === "municipality-sections") {
			return {
				name: `${t("departmentSections")} `,
				link: `/municipality-sections`,
				active:
					props.currentPage === "/municipality-sections"
						? true
						: false,
				Icon: <MunicipalitiesSections />,
			};
		}
		if (item === "municipality-centers") {
			return {
				name: `${t("departmentcenters")} `,
				link: `/municipality-centers`,
				active:
					props.currentPage === "/municipality-centers"
						? true
						: false,
				Icon: <MunicipalitiesCenters />,
			};
		}
		if (item === "municipality-jobs") {
			return {
				name: `${t("departmentJobs")} `,
				link: `/municipality-jobs`,
				active:
					props.currentPage === "/municipality-jobs" ? true : false,
				Icon: <MunicipalitiesJobs />,
			};
		}
		if (item === "all-tasks") {
			return {
				name: `${t("AllTasks")} `,
				link: `/all-tasks`,
				active: props.currentPage === "/all-tasks" ? true : false,
				Icon: <MunicipalitiesJobs />,
			};
		}
		if (item === "assigned-tasks") {
			return {
				name: `${t("manageAssignedTasks")} `,
				link: `/assigned-tasks`,
				active: props.currentPage === "/assigned-tasks" ? true : false,
				Icon: <MunicipalitiesJobs />,
			};
		}
		if (item === "my-tasks") {
			return {
				name: `${t("myTasks")} `,
				link: `/my-tasks`,
				active: props.currentPage === "/my-tasks" ? true : false,
				Icon: <MunicipalitiesJobs />,
			};
		}
		if (item === "manage-suspensions") {
			return {
				name: `${t("manageSuspensions")} `,
				link: `/manage-suspensions`,
				active:
					props.currentPage === "/manage-suspensions" ? true : false,
				Icon: <UsersGroups />,
			};
		}
		if (item === "suspensions") {
			return {
				name: `${t("suspensionsList")} `,
				link: `/suspensions`,
				active: props.currentPage === "/suspensions" ? true : false,
				Icon: <UsersGroups />,
			};
		}
	});

	let manageServicesArray = allowedScreens.map((item) => {
		if (item === "holiday") {
			return {
				name: `${t("manageHolidays")} `,
				link: `/holidays`,
				active: props.currentPage === "/holidays" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "manage-system-modules") {
			return {
				name: `${t("manageSystemModules")} `,
				link: `/manage-system-modules`,
				active:
					props.currentPage === "/manage-system-modules"
						? true
						: false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "system-modules-apis") {
			return {
				name: `${t("manageSystemModulesApis")} `,
				link: `/system-modules-apis`,
				active:
					props.currentPage === "/system-modules-apis" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		// if (item === "types-of-documents") {
		//   return ({
		//     name: `${t('typesOfDocuments')} `,
		//     link: `/types-of-documents`,
		//     active: props.currentPage === '/types-of-documents' ? true : false,
		//     Icon: <SuggestionComplaints />
		//   })
		// }
		// if (item === "types-of-stamps") {
		//   return ({
		//     name: `${t('typesOfStamps')} `,
		//     link: `/types-of-stamps`,
		//     active: props.currentPage === '/types-of-stamps' ? true : false,
		//     Icon: <SuggestionComplaints />
		//   })
		// }
		if (item === "manage-modules") {
			return {
				name: `${t("manageModules")} `,
				link: `/manage-modules`,
				active: props.currentPage === "/manage-modules" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "services") {
			return {
				name: `${t("ServiceRegistration")} `,
				link: `/services`,
				active:
					props.currentPage === "/services" ||
					props.currentPage === "/services/add-service"
						? true
						: false,
				Icon: <ManageServices />,
			};
		}
		if (item === "services/categories") {
			return {
				name: `${t("ServicesCategories")} `,
				link: `/services/categories`,
				active:
					props.currentPage === "/services/categories" ? true : false,
				Icon: <ServiceCategories />,
			};
		}
		if (item === "services/drop-downs") {
			return {
				name: `${t("ServicesDrop-Downs")} `,
				link: `/services/drop-downs`,
				active:
					props.currentPage === "/services/drop-downs" ? true : false,
				Icon: <ServiceDropDown />,
			};
		}
		if (item === "services/municipalities-services") {
			return {
				name: `${t("municipalitiesServices")} `,
				link: `/services/municipalities-services`,
				active:
					props.currentPage === "/services/municipalities-services"
						? true
						: false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "invoices-list") {
			return {
				name: `${t("invoicesList")} `,
				link: `/invoices-list`,
				active: props.currentPage === "/invoices-list" ? true : false,
				Icon: <ServiceDropDown />,
			};
		}
		if (item === "servicies-requests") {
			return {
				name: `${t("ServiceRequests")} `,
				link: `/servicies-requests`,
				active:
					props.currentPage === "/admin-services-dashboard"
						? true
						: false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "manage-payments") {
			return {
				name: `${t("managePaymentTypes")} `,
				link: `/manage-payments`,
				active: props.currentPage === "/manage-payments" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		// if(item === 'services/municipalities-services') {
		//   return (
		//       {
		//         name: `${ t('municipalitiesServices') } `,
		//         link: `/services/municipalities-services`,
		//         active: props.currentPage === '/services/municipalities-services' ? true : false,
		//         Icon: <ManageMunicipalities />
		//       }
		//   )
		// }
	});

	let managePortal = allowedScreens.map((item) => {
		if (item === "support-request") {
			return {
				name: `${t("supportRequest")} `,
				link: `/support-request`,
				active: props.currentPage === "/support-request" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "accounts") {
			return {
				name: `${t("manageAccounts")} `,
				link: `/accounts`,
				active: props.currentPage === "/accounts" ? true : false,
				Icon: <UserManagement />,
			};
		}
		if (item === "slider") {
			return {
				name: `${t("manageSlider")} `,
				link: `/slider`,
				active: props.currentPage === "/slider" ? true : false,
				Icon: <ManageSlider />,
			};
		}
		if (item === "suggestionsAndComplains") {
			return {
				name: `${t("suggestionsAndComplains")} `,
				link: `/suggestionsAndComplains`,
				active:
					props.currentPage === "/suggestionsAndComplains"
						? true
						: false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "decision-categories") {
			return {
				name: `${t("manageDecisionCategories")} `,
				link: `/decision-categories`,
				active:
					props.currentPage === "/decision-categories" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "decisions") {
			return {
				name: `${t("manageDecisions")} `,
				link: `/decisions`,
				active: props.currentPage === "/decisions" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "government-entities") {
			return {
				name: `${t("manangeGovEnt")} `,
				link: `/government-entities`,
				active:
					props.currentPage === "/government-entities" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "faq-list") {
			return {
				name: `${t("manageFaqList")} `,
				link: `/faq-list`,
				active: props.currentPage === "/faq-list" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "housing-departments") {
			return {
				name: `${t("manageHousingDepartments")} `,
				link: `/housing-departments`,
				active:
					props.currentPage === "/housing-departments" ? true : false,
				Icon: <UserManagement />,
			};
		}
	});

	let manageSystem = allowedScreens.map((item) => {
		if (item === "customer-services") {
			return {
				name: `${t("CustomerServicesSettings")} `,
				link: `/customer-services`,
				active:
					props.currentPage === "/customer-services" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "users-areas") {
			return {
				name: `${t("UsersAreasSettings")} `,
				link: `/users-areas`,
				active: props.currentPage === "/users-areas" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "settings") {
			return {
				name: `${t("ManageSettings")} `,
				link: `/settings`,
				active: props.currentPage === "/settings" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
		if (item === "Users") {
			return {
				name: `${t("manageUsers")} `,
				link: `/users`,
				active: props.currentPage === "/users" ? true : false,
				Icon: <UserManagement />,
			};
		}
		if (item === "Users_Groups") {
			return {
				name: `${t("usersGroups")} `,
				link: `/users-groups`,
				active: props.currentPage === "/usersGroups" ? true : false,
				Icon: <UsersGroups />,
			};
		}
		if (item === "manage-notifications") {
			return {
				name: `${t("manageNotifications")} `,
				link: `/manage-notifications`,
				active:
					props.currentPage === "/manage-notifications"
						? true
						: false,
				Icon: <UsersGroups />,
			};
		}
		if (item === "employee-transactions") {
			return {
				name: `${t("employeeTransactions")} `,
				link: `/employee-transactions`,
				active:
					props.currentPage === "/employee-transactions"
						? true
						: false,
				Icon: <UsersGroups />,
			};
		}
		if (item === "used-devices") {
			return {
				name: `${t("usedDevicesReport")} `,
				link: `/used-devices`,
				active: props.currentPage === "/used-devices" ? true : false,
				Icon: <UsersGroups />,
			};
		}

		if (item === "types-of-documents") {
			return {
				name: `${t("typesOfDocuments")} `,
				link: `/types-of-documents`,
				active:
					props.currentPage === "/types-of-documents" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "types-of-stamps") {
			return {
				name: `${t("typesOfStamps")} `,
				link: `/types-of-stamps`,
				active: props.currentPage === "/types-of-stamps" ? true : false,
				Icon: <SuggestionComplaints />,
			};
		}
		if (item === "users-dashboard-list") {
			return {
				name: `${t("usersDashboardMenu")} `,
				link: `/users-dashboard-list`,
				active:
					props.currentPage === "/users-dashboard-list"
						? true
						: false,
				Icon: <UsersDashboardMenu />,
			};
		}

		if (item === "Control-panel-card-settings") {
			return {
				name: `${t("cardSettings")} `,
				link: `/cards`,
				active: props.currentPage === "/cards" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
	});

	let manageViolations = allowedScreens.map((item) => {
		if (item === "manage-violations") {
			return {
				name: `${t("violationsList")} `,
				link: `/manage-violations`,
				active:
					props.currentPage === "/manage-violations" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}

		if (item === "violation-categories") {
			return {
				name: `${t("violationCategoriesList")} `,
				link: `/violation-categories`,
				active:
					props.currentPage === "/violation-categories"
						? true
						: false,
				Icon: <ManageMunicipalities />,
			};
		}

		if (item === "violation-types") {
			return {
				name: `${t("violationTypesList")} `,
				link: `/violation-types`,
				active: props.currentPage === "/violation-types" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}

		if (item === "manage-blocks") {
			return {
				name: `${t("blocksList")} `,
				link: `/manage-blocks`,
				active: props.currentPage === "/manage-blocks" ? true : false,
				Icon: <ManageMunicipalities />,
			};
		}
	});

	// console.log(allowedScreens);

	allowedPagesMain = allowedPagesMain.filter((item) => item !== undefined);
	manageServicesArray = manageServicesArray.filter(
		(item) => item !== undefined
	);
	managePortal = managePortal.filter((item) => item !== undefined);
	manageSystem = manageSystem.filter((item) => item !== undefined);
	manageViolations = manageViolations.filter((item) => item !== undefined);

	const mainObject =
		allowedPagesMain.length > 0
			? {
					items: [
						{
							name: `${t("mainData")} `,
							link: ``,
							active: allowedPagesMain.some(
								(item) => item.link === props.currentPage
							),
							Icon: <ManageMunicipalities />,
							children: [
								{
									name: `${t("mainData")} `,
									link: ``,
									active: allowedPagesMain.some(
										(item) =>
											item.link === props.currentPage
									),
									Icon: <ManageMunicipalities />,
									children: [...allowedPagesMain],
								},
							],
						},
					],
			  }
			: false;

	const serviceObject =
		manageServicesArray.length > 0
			? {
					items: [
						{
							name: `${t("manageServices")} `,
							link: ``,
							active: manageServicesArray.some(
								(item) => item.link === props.currentPage
							),
							Icon: <ManageMunicipalities />,
							children: [
								{
									name: `${t("manageServices")} `,
									link: ``,
									active: manageServicesArray.some(
										(item) =>
											item.link === props.currentPage
									),
									Icon: <ManageMunicipalities />,
									children: [...manageServicesArray],
								},
							],
						},
					],
			  }
			: false;

	const portalObject =
		managePortal.length > 0
			? {
					items: [
						{
							name: `${t("managePortal")} `,
							link: ``,
							active: managePortal.some(
								(item) => item.link === props.currentPage
							),
							Icon: <ManageMunicipalities />,
							children: [
								{
									name: `${t("managePortal")} `,
									link: ``,
									active: managePortal.some(
										(item) =>
											item.link === props.currentPage
									),
									Icon: <ManageMunicipalities />,
									children: [...managePortal],
								},
							],
						},
					],
			  }
			: false;

	const systemObject =
		manageSystem.length > 0
			? {
					items: [
						{
							name: `${t("systemAdministration")} `,
							link: ``,
							active: manageSystem.some(
								(item) => item.link === props.currentPage
							),
							Icon: <ManageMunicipalities />,
							children: [
								{
									name: `${t("systemAdministration")} `,
									link: ``,
									active: manageSystem.some(
										(item) =>
											item.link === props.currentPage
									),
									Icon: <ManageMunicipalities />,
									children: [...manageSystem],
								},
							],
						},
					],
			  }
			: false;

	const violationsObject =
		manageViolations.length > 0
			? {
					items: [
						{
							name: `${t("violationAdministration")} `,
							link: ``,
							active: manageViolations.some(
								(item) => item.link === props.currentPage
							),
							Icon: <ManageMunicipalities />,
							children: [
								{
									name: `${t("violationAdministration")} `,
									link: ``,
									active: manageViolations.some(
										(item) =>
											item.link === props.currentPage
									),
									Icon: <ManageMunicipalities />,
									children: [...manageViolations],
								},
							],
						},
					],
			  }
			: false;

	const appMenuItems = [
		mainObject,
		serviceObject,
		portalObject,
		systemObject,
		violationsObject,
	];

	const dahboardLink = {
		name: props.currentUser.Data.Department_Job_Type_Id
			? `${t("dashboard")}`
			: null,
		link: `/ `,
		active: props.currentPage === "/" ? true : false,
		Icon: props.currentUser.Data.Department_Job_Type_Id ? (
			<MenuIcon />
		) : null,
	};

	const structuralAuditingLink = {
		name: props.currentUser.Data.Department_Job_Type_Id
			? `${t("structuralAuditing")}`
			: null,
		link: `/structuralAuditing `,
		active: props.currentPage === "/structuralAuditing" ? true : false,
		Icon: props.currentUser.Data.Department_Job_Type_Id ? (
			<MenuIcon />
		) : null,
	};

	if (appMenuItems[0]) {
		appMenuItems[0].items.unshift(structuralAuditingLink);
		appMenuItems[0].items.unshift(dahboardLink);
	}

	return (
		<>
			<List
				onMouseEnter={props.onOpenOnHover}
				onMouseLeave={props.onCloseAfterHover}
				className={style.list}
			>
				{appMenuItems?.map((item, index) => (
					<MenuItem
						{...item}
						key={index}
						menuIsOpen={props.onOpen}
						respIsOpen={props.onOpenResp}
					/>
				))}
			</List>

			<Location>
				{({ location }) => {
					props.setCurrentPage(location.pathname);
				}}
			</Location>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		currentPage: state.currentPage,
		currentUser: state.currentUser,
	};
};

export default connect(mapStateToProps, { setCurrentPage })(Menu);
